import PropTypes from 'prop-types';
import { reduxPropTypes } from '@figure/frontlib-onboarding-redux';
import { Button, Label } from '@figure/frontlib-gui';
import { FIGURE, selectByTheme } from 'shared/utils/ThemeHelper';
import { RightTableCell } from './RightTableCell';

/**
 * These Disclosures used to be referenced as static imports, but As Provenance needed to have a record of them in the loan tape.
 * they are now dynamically attached to every app. This component just wraps the <tr> list shared by a few components.
 * @param disclosures
 */
const StaticDisclosureRows = ({ disclosures }) => {
  // legacy behavior did not send these in the disclosure list. so we need to maintain the static assets
  const hasGLBANotice = disclosures.find((d) => d.document.type === 'GLBA_NOTICE');
  return (
    <>
      {!hasGLBANotice && (
        <tr>
          <td>
            <Label>GLBA Privacy Notice Form</Label>
          </td>
          <RightTableCell>
            <a
              href={selectByTheme({
                [FIGURE]: '/glba-privacy-notice.pdf',
              })}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button secondary large>
                Download
              </Button>
            </a>
          </RightTableCell>
        </tr>
      )}
    </>
  );
};

StaticDisclosureRows.propTypes = {
  disclosures: PropTypes.arrayOf(reduxPropTypes.disclosure),
};

StaticDisclosureRows.defaultProps = {
  disclosures: [],
};

export default StaticDisclosureRows;
